import {
    GET_OUTSTANDING_REPORT_PROGRESS, GET_OUTSTANDING_REPORT_SUCCESS, GET_OUTSTANDING_REPORT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    outstanding: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const outstanding_report_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_OUTSTANDING_REPORT_SUCCESS:
            return { ...state, outstanding: action.outstanding, loading: false };
        case GET_OUTSTANDING_REPORT_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_OUTSTANDING_REPORT_PROGRESS:
            return { ...state, loading: true, error: false };
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message
        default:
            return state
    }
}

export default outstanding_report_reducer;